/* eslint-disable import/no-cycle */
import { isFirefox } from 'react-device-detect';
import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import {
  AHORRO,
  COMMERCIAL_EN,
  COMMERCIAL_ES,
  CUENTA_LIBRE,
  ESCROWACCEN,
  ESNON_PROFIT,
  LIBRE_ACCOUNT,
  MYBIZ_EN,
  NONPROFIT,
  PROGRESA_CONTIGO,
} from '../../constants';
import { isPlaidProduct } from '../commonCode';

export const commonUtility = (value) => {
  if (value) {
    return value;
  }
  return null;
};
export const commonUtilityStringValue = (value) => {
  if (value) {
    return value;
  }
  return '';
};

export const formattedDepositAmount = (depositAmount) => {
  if (depositAmount) {
    return depositAmount?.toString()?.replace(/[^\w\s]/gi, '');
  }
  return null;
};

let updatedDepositAmount;
export const formattedDepositAmntForRegular = (depositAmount) => {
  if (depositAmount) {
    updatedDepositAmount = depositAmount?.replace(/[^\w\s]/gi, '');
    return `${updatedDepositAmount}.00`;
  }
  return null;
};

export const commonUtilityValueReturn = (condition, returnValue1, returnValue2) => {
  if (condition) {
    return returnValue1;
  }
  return returnValue2;
};

export const commonUtilityBooleanChk = (value) => {
  if (value) {
    return value;
  }
  return false;
};

export const checkFirefoxBrowser = (value1, value2) => {
  if (isFirefox) {
    return value1;
  }
  return value2;
};

export const getProductForDebitCard = (productName) => {
  let found = false;
  if (
    productName === 'Libre Account' ||
    productName === 'Cuenta Libre' ||
    // productName === 'Progresa Account' ||
    // productName === 'Cuenta Progresa' ||
    productName === 'Junior Account' ||
    productName === 'Easy Access Account' ||
    productName === 'Complete Checking Account' ||
    productName === 'Oriental Savings Account' ||
    productName === 'Progresa Contigo'
  ) {
    found = true;
  }
  return found;
};

export const getProductForDepositeCard = (productName) => {
  let found = false;
  if (
    productName === 'Progresa Account' ||
    productName === 'Cuenta Progresa' ||
    productName === 'Libre Account' ||
    productName === 'Cuenta Libre'
  ) {
    found = true;
  }
  return found;
};

export const getProductForBusinessMapping = (productName) => {
  let found = false;
  if (
    productName === MYBIZ_EN ||
    productName === NONPROFIT ||
    productName === ESNON_PROFIT ||
    productName === ESCROWACCEN ||
    productName === AHORRO ||
    productName === COMMERCIAL_EN ||
    productName === COMMERCIAL_ES
  ) {
    found = true;
  }
  return found;
};
export const getProductForBusinessMappingCredit = (productName) => {
  let found = true;
  if (
    productName === MYBIZ_EN ||
    productName === ESCROWACCEN ||
    productName === AHORRO ||
    productName === NONPROFIT ||
    productName === ESNON_PROFIT ||
    productName === COMMERCIAL_EN ||
    productName === COMMERCIAL_ES
  ) {
    found = false;
  }
  return found;
};
export const getProductForEstatement = (productName) => {
  const products = [LIBRE_ACCOUNT, CUENTA_LIBRE, PROGRESA_CONTIGO];
  return products.includes(productName);
};
export const getLang = (language, toLowerCase = false) => {
  let lang = 'En';
  if (language === 'ES') {
    lang = 'Es';
  }

  if (toLowerCase) return lang.toLowerCase();

  return lang;
};
function cryptoRandom(len) {
  const uuid = uuidv4().replace(/-/g, '');
  return uuid.slice(0, len);
}
export const encryptData = (str, code) => {
  const prefix = cryptoRandom(16);
  const ivdata = CryptoJS.enc.Utf8.parse(code.substring(0, 16));
  const key = CryptoJS.enc.Utf8.parse(code);

  return AES.encrypt(prefix + str, key, {
    iv: ivdata,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

// eslint-disable-next-line arrow-body-style
export const generateKey = () => {
  return cryptoRandom(32);
};
export const getNameInUpperCase = (name) => {
  if (name?.includes(' ')) {
    const words = name.toLowerCase().split(' ');
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};
export const identifyCustomerType = (ctx, productName, customerType) => {
  ctx.setPlaidDetails({
    flowType: '',
    status: '',
    remarks: '',
    verificationType: '',
  });
  ctx.setOrientalAccountCardValue({
    Id: '',
  });
  ctx.setPlaidSuccessDetails({
    accId: '',
  });
  ctx.setPlaidAccNoLinked([]);
  if (isPlaidProduct(productName) && customerType === 'NTB') {
    ctx.setFundDataErrors({});
    ctx.setFundData((prevState) => ({
      ...prevState,
      orientalAccount: false,
      anotherBankAccount: true,
      Id: '',
      depositAmount: '',
      sourceofFunds: '',
      accountNumber: '',
      typeOfAccount: '',
      otherBank: '',
      bank: '',
      transitNumber: '',
    }));
  } else if (isPlaidProduct(productName) && customerType === 'ETB') {
    ctx.setFundDataErrors({});
    ctx.setFundData((prevState) => ({
      ...prevState,
      Id: '',
      accountNumber: '',
      typeOfAccount: '',
      depositAmount: '',
      otherBank: '',
      bank: '',
      transitNumber: '',
      orientalAccount: true,
      anotherBankAccount: false,
      sourceofFunds: '',
    }));
    ctx.setStatementDocumentId(null);
    ctx.setStatementUploadStatus(null);
  }
};
